import AddIcon from '@mui/icons-material/Add';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorScreen from '../../../core-components/theme/components/ErrorScreen';
import SearchBox from '../../../core-components/theme/components/Searchbox/Searchbox';
import Theme from '../../../core-components/theme/theme';
import Loader from '../../../globalComponents/loader/DPLoader';
import { useBatchConfigList } from '../hooks/useBatchConfigList';
import BatchConfigTable from './BatchConfigTable';
// import BatchConfigDialog from '../Dialogs/BatchConfigDialog';
import { useParams } from 'react-router-dom';
import Button from '../../../core-components/theme/components/Button/Button';
import { ANALYTICS_RULES, atPlant, useCan } from '../../../access';

export default function BatchConfigListing() {
  const { t } = useTranslation();
  const { assetId = '' } = useParams() as { assetId: string };
  const canConfigureBatches = useCan(ANALYTICS_RULES.manageBatches, atPlant(assetId));
  const { searchString, isPending, handleSearch, handleAddBatchConfig, handleRowClick} =
    useBatchConfigList();
  const isTablet = useMediaQuery(Theme.breakpoints.down('md'));
  return (
      <Stack direction="column" spacing={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="title">
            {t('batchConfig.batchList', 'Batch List')}
          </Typography>
          {canConfigureBatches && (<>
            <Button
              onClick={handleAddBatchConfig}
              aria-label={t('batchConfig.addNewAriaLabel', 'Add a new Batch Configuration')}
            >
              <Stack direction="row" alignItems="center" gap={2}>
              <AddIcon />
                {!isTablet && (
                    t('batchConfig.configureNewBatch', 'CONFIGURE NEW BATCH')
                )}
              </Stack>
            </Button>
          </>)}
        </Stack>

        <SearchBox
          placeholder={t('batchConfig.searchBatch', 'Search Batch')}
          onSearch={value => handleSearch(value)}
          onClear={() => handleSearch('')}
        />

        <Box width="100%">
          <ErrorBoundary fallback={<ErrorScreen />}>
            <Suspense fallback={<Loader height="40vh" />}>
              <BatchConfigTable isPending={isPending} searchString={searchString}  onRowClick={handleRowClick} assetId={assetId}/>
            </Suspense>
          </ErrorBoundary>
        </Box>

      </Stack>
  );
}
